import React, { FC, useEffect } from 'react'
import styles from './PlatformCardShortInformation.module.css'
import { EstablishmentsType, PlaceType } from '../../redux/actions/types'
import { useNavigate } from 'react-router-dom'
import PATH from '../../navigation/path'

export type PlatformCardShortInformationPropsType = {
  platformData: PlaceType | EstablishmentsType
  forEstablishment?: boolean
  publicPlace?: boolean
}

const PlatformCardShortInformation: FC<PlatformCardShortInformationPropsType> = ({
  platformData,
  publicPlace,
}) => {
  const navigate = useNavigate()

  const redirectToCompanyCard = () => {
    navigate(`${PATH.companyPage}${platformData.company.id}`)
  }

  const redirectToEstablishmentCard = () => {
    navigate(
      `${PATH.establishmentCardPage}${(platformData.establishment as EstablishmentsType).id}`,
    )
  }

  return (
    <div className={styles.shortInformationBlock}>
      <div className={styles.container}>
        <div className={styles.leftBlock}>
          <div className={styles.cityBlock}>
            <p className={styles.cityTitle}>Город:</p>
            <p className={styles.cityName}>{platformData.city}</p>
          </div>
          <div className={styles.cityBlock}>
            <p className={styles.cityTitle}>Адрес:</p>
            <p className={styles.cityName}>{platformData.address}</p>
          </div>
        </div>
        <div className={styles.rightBlock}>
          <div className={styles.companyNameBlock}>
            <p className={styles.companyNameTitle}>Компания:</p>
            <p
              style={{
                color: publicPlace ? 'rgba(25, 25, 25, 1)' : 'rgba(24, 85, 153, 1)',
              }}
              className={styles.companyName}
              onClick={publicPlace ? undefined : redirectToCompanyCard}
            >
              {platformData.company.name}
            </p>
          </div>
          {platformData.establishment && (
            <div className={styles.companyNameBlock}>
              <p className={styles.companyNameTitle}>Площадка:</p>
              <p
                className={styles.establishmentName}
                onClick={publicPlace ? undefined : redirectToEstablishmentCard}
              >
                {(platformData.establishment as EstablishmentsType).name}
              </p>
            </div>
          )}
          {platformData.size && (
            <div className={styles.capacityBlock}>
              <p className={styles.capacityTitle}>Вместимость: </p>
              <p className={styles.capacityName}>{`${platformData.size} человек(а)`}</p>
            </div>
          )}
          {platformData.description && (
            <div className={styles.capacityBlock}>
              <p className={styles.capacityTitle}>Описание</p>
              <p className={styles.capacityName}>{`${platformData.description}`}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PlatformCardShortInformation
